import type { ProductClientDetails } from '@avalara/types/product-detail';
import type { ProductDetailState } from '@avalara/types/reducer-states';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: ProductDetailState = {
  productKey: '',
  featureSections: [],
  pricingTiers: { items: [] },
  faqs: { items: [] },
  fetchStatus: 'PENDING',
};

const isProductClientDetails = (
  payload: ProductClientDetails | 'NOT_FOUND' | 'ERROR',
): payload is ProductClientDetails => payload !== 'NOT_FOUND' && payload !== 'ERROR';

const store = createSlice({
  name: 'productDetail',
  initialState,
  reducers: {
    // Kept distinct from NOT_FOUND: a 404 means the product genuinely doesn't exist, while ERROR
    // means the fetch itself failed (network/5xx) — collapsing the two would render a "not found"
    // page for what's actually a transient outage, contradicting the error toast dispatched
    // alongside it in fetchProductDetail.
    setProductDetail: (_state, action: PayloadAction<ProductClientDetails | 'NOT_FOUND' | 'ERROR'>) =>
      isProductClientDetails(action.payload)
        ? { ...action.payload, fetchStatus: 'SUCCESS' }
        : { ...initialState, fetchStatus: action.payload },
  },
});

export const { setProductDetail } = store.actions;

export default store;
